import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import toggleSideNav from 'modules/_shared/redux/sideNavActions';
import { getConfigByCorporateId } from 'modules/_custom/utils/getConfigByCorporateId';

import '../SideNav.scss';

const billingUrl = process.env.REACT_APP_STRIPE_BILLING_URL || null;

const SecondaryMenu: FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const {
    showProfileDataTab,
    showSupportOption,
    showSubscriptionOption,
    showContactOption,
  } = getConfigByCorporateId();

  return (
    <ul className="nk-menu nk-menu-sm" id="secondary-menu__fixed">
      <li className="nk-menu-heading">
        <span>{t('Account')}</span>
      </li>

      {showProfileDataTab && (
        <li className="nk-menu-item">
          <Link
            to="/perfil-usuario/datos"
            className="nk-menu-link"
            onClick={() => dispatch(toggleSideNav())}
          >
            <span className="nk-menu-icon">
              <em className="icon ni ni-user-round" />
            </span>
            <span className="nk-menu-text">{t('MyData')}</span>
          </Link>
        </li>
      )}

      {showSubscriptionOption && (
        <li className="nk-menu-item">
          <Link
            to={billingUrl || '/'}
            target="_blank"
            rel="noreferrer"
            className={`nk-menu-link ${billingUrl ? '' : 'is-disable'}`}
            onClick={() => dispatch(toggleSideNav())}
          >
            <span className="nk-menu-icon">
              <em className="icon ni ni-report-profit" />
            </span>
            <span className="nk-menu-text">{t('Subscription')}</span>
          </Link>
        </li>
      )}

      {showContactOption && (
        <li className="nk-menu-item">
          <Link
            to="/contacto"
            className="nk-menu-link"
            onClick={() => dispatch(toggleSideNav())}
          >
            <span className="nk-menu-icon">
              <em className="icon ni ni-external" />
            </span>
            <span className="nk-menu-text">{t('Contact')}</span>
          </Link>
        </li>
      )}

      {showSupportOption && (
        <li className="nk-menu-item">
          <a
            href="https://ayuda.sttok.com/"
            target="_blank"
            rel="noreferrer"
            className="nk-menu-link"
            onClick={() => dispatch(toggleSideNav())}
          >
            <span className="nk-menu-icon">
              <em className="icon ni ni-info" />
            </span>
            <span className="nk-menu-text">{t('Help')}</span>
          </a>
        </li>
      )}
    </ul>
  );
};

export default SecondaryMenu;
